/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Start_Event_Char_LabelInputs */



/**
* | output |
* | --- |
* | "Start Event On Character" |
*
* @param {Plain_Text_Import_Start_Event_Char_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_start_event_char_label = /** @type {((inputs?: Plain_Text_Import_Start_Event_Char_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Start_Event_Char_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demarrer l'evenement sur caractere")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis mit Charakter starten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvia evento sul personaggio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начало события для персонажа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciar evento en el personaje")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("角色开始事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャラクターのイベント開始")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चरित्र पर घटना प्रारंभ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciar evento no personagem")
	return /** @type {LocalizedString} */ ("Start Event On Character")
});